import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTema } from '../ThemeContext';
import { useGyerekek } from '../GyerekekContext';

function Navbar({ felhasznalo, kijelentkezes }) {
  const [menuNyitva, setMenuNyitva] = useState(false);
  const location = useLocation();
  const { tema, temaValtas } = useTema();
  const { gyerekek } = useGyerekek();
  const aktivGyerek = gyerekek[0] || null;

  const menupontok = [
    { nev: 'Főoldal', utvonal: '/', ikon: '🏠' },
    { nev: 'Tanulás', utvonal: '/temakork', ikon: '📚' },
    { nev: 'Szülőknek', utvonal: '/szuloknek', ikon: '👨‍👩‍👧' },
  ];

  return (
    <>
      <style>{`
        .navbar {
          position: fixed;
          top: 0; left: 0; right: 0;
          z-index: 1000;
          background: rgba(255,255,255,0.97);
          backdrop-filter: blur(20px);
          border-bottom: 2px solid #f0f0f0;
          box-shadow: 0 4px 24px rgba(0,0,0,0.08);
        }
        .navbar-inner {
          max-width: 1240px;
          margin: 0 auto;
          padding: 0 2rem;
          height: 88px;
          display: flex;
          align-items: center;
          gap: 2.25rem;
        }
        .navbar-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          text-decoration: none;
          flex-shrink: 0;
          transition: transform 0.2s;
        }
        .navbar-logo:hover { transform: scale(1.03); }
        .navbar-logo-kep-keret {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          border-radius: 18px;
          background: linear-gradient(135deg, #e3f2fd, #f3e5f5);
          box-shadow: 0 4px 14px rgba(26,115,232,0.18);
          flex-shrink: 0;
        }
        .navbar-logo img { height: 44px; width: auto; display: block; }
        .navbar-logo-text {
          font-size: 27px;
          font-weight: 900;
          letter-spacing: -0.5px;
          background: linear-gradient(135deg, #1a73e8, #9c27b0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .navbar-menu {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex: 1;
        }
        .navbar-link {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 18px;
          border-radius: 50px;
          text-decoration: none;
          font-size: 15px;
          font-weight: 700;
          color: #555;
          transition: all 0.2s;
          white-space: nowrap;
        }
        .navbar-link:hover { background: #f0f7ff; color: #1a73e8; }
        .navbar-link.aktiv {
          background: linear-gradient(135deg, #1a73e8, #4fc3f7);
          color: white;
          box-shadow: 0 4px 12px rgba(26,115,232,0.3);
        }
        .navbar-tema-gomb {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 2px solid #e0e0e0;
          background: white;
          cursor: pointer;
          font-size: 19px;
          transition: all 0.2s;
          flex-shrink: 0;
        }
        .navbar-tema-gomb:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-color: #1a73e8; }
        .navbar-mobil-tema-sor {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 16px;
        }
        .navbar-jobb {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex-shrink: 0;
        }
        .navbar-profil-gomb {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 18px 8px 8px;
          background: linear-gradient(135deg, #f3e5f5, #e8f5e9);
          border: 2px solid #e0e0e0;
          border-radius: 50px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 700;
          color: #333;
          text-decoration: none;
          transition: all 0.2s;
        }
        .navbar-gyerek-avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          flex-shrink: 0;
        }
        .navbar-profil-gomb:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.1); transform: translateY(-1px); }
        .navbar-kijel-gomb {
          padding: 10px 18px;
          background: #ffebee;
          border: 2px solid #ffcdd2;
          border-radius: 50px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 700;
          color: #c62828;
          transition: all 0.2s;
          white-space: nowrap;
        }
        .navbar-kijel-gomb:hover { background: #ffcdd2; }
        .navbar-belepes-gomb {
          padding: 12px 28px;
          background: linear-gradient(135deg, #1a73e8, #4fc3f7);
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-size: 15px;
          font-weight: 700;
          color: white;
          text-decoration: none;
          box-shadow: 0 4px 14px rgba(26,115,232,0.35);
          transition: all 0.2s;
          white-space: nowrap;
        }
        .navbar-belepes-gomb:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(26,115,232,0.45); }
        .navbar-hamburger {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
          padding: 8px;
          border: none;
          background: none;
          margin-left: auto;
        }
        .navbar-hamburger span {
          display: block;
          width: 26px;
          height: 3px;
          background: #333;
          border-radius: 2px;
          transition: all 0.3s;
        }
        .navbar-mobil-menu {
          display: none;
          flex-direction: column;
          padding: 1rem;
          border-top: 1px solid #f0f0f0;
          background: white;
          gap: 0.5rem;
        }
        .navbar-mobil-menu.nyitva { display: flex; }
        .navbar-mobil-link {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 16px;
          border-radius: 14px;
          text-decoration: none;
          font-size: 16px;
          font-weight: 600;
          color: #555;
          transition: all 0.2s;
        }
        .navbar-mobil-link:hover { background: #f0f7ff; color: #1a73e8; }
        .navbar-mobil-link.aktiv {
          background: linear-gradient(135deg, #1a73e8, #4fc3f7);
          color: white;
        }
        .navbar-mobil-elvalaszto {
          height: 1px;
          background: #f0f0f0;
          margin: 0.5rem 0;
        }
        @media (max-width: 768px) {
          .navbar-menu { display: none; }
          .navbar-jobb { display: none; }
          .navbar-hamburger { display: flex; }
          .navbar-inner { padding: 0 1rem; height: 76px; }
          .navbar-logo-kep-keret { width: 48px; height: 48px; border-radius: 14px; }
          .navbar-logo img { height: 34px; }
          .navbar-logo-text { font-size: 20px; }
        }
      `}</style>

      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo" onClick={() => setMenuNyitva(false)}>
            <div className="navbar-logo-kep-keret">
              <img src="/NetOkos_log.png" alt="NetOkos"/>
            </div>
            <span className="navbar-logo-text">NetOkos</span>
          </Link>

          {/* Desktop menü */}
          <div className="navbar-menu">
            {menupontok.map(mp => (
              <Link key={mp.utvonal} to={mp.utvonal} className={`navbar-link ${location.pathname === mp.utvonal ? 'aktiv' : ''}`}>
                <span>{mp.ikon}</span>{mp.nev}
              </Link>
            ))}
          </div>

          {/* Desktop jobb */}
          <div className="navbar-jobb">
            <button className="navbar-tema-gomb" onClick={temaValtas} title={tema === 'sotet' ? 'Világos mód' : 'Sötét mód'}>
              {tema === 'sotet' ? '☀️' : '🌙'}
            </button>
            {felhasznalo ? (
              <>
                <Link to="/profil" className="navbar-profil-gomb">
                  {aktivGyerek?.avatar ? (
                    <span className="navbar-gyerek-avatar" style={{background: `linear-gradient(135deg, ${aktivGyerek.avatar.szin1}, ${aktivGyerek.avatar.szin2})`}}>
                      {aktivGyerek.avatar.ikon}
                    </span>
                  ) : (
                    <span>👤</span>
                  )}
                  {aktivGyerek?.nev || felhasznalo.displayName || felhasznalo.email?.split('@')[0] || 'Profil'}
                </Link>
                <button onClick={kijelentkezes} className="navbar-kijel-gomb">Kilépés</button>
              </>
            ) : (
              <Link to="/belepes" className="navbar-belepes-gomb">🚀 Belépés</Link>
            )}
          </div>

          {/* Hamburger */}
          <button className="navbar-hamburger" onClick={() => setMenuNyitva(!menuNyitva)}>
            <span style={{transform: menuNyitva ? 'rotate(45deg) translate(5px, 5px)' : 'none'}}/>
            <span style={{opacity: menuNyitva ? 0 : 1}}/>
            <span style={{transform: menuNyitva ? 'rotate(-45deg) translate(5px, -5px)' : 'none'}}/>
          </button>
        </div>

        {/* Mobil menü */}
        <div className={`navbar-mobil-menu ${menuNyitva ? 'nyitva' : ''}`}>
          <div className="navbar-mobil-tema-sor">
            <span style={{fontSize: '15px', fontWeight: 700, color: '#333'}}>
              {tema === 'sotet' ? '🌙 Sötét mód' : '☀️ Világos mód'}
            </span>
            <button className="navbar-tema-gomb" onClick={temaValtas}>
              {tema === 'sotet' ? '☀️' : '🌙'}
            </button>
          </div>
          <div className="navbar-mobil-elvalaszto"/>
          {menupontok.map(mp => (
            <Link key={mp.utvonal} to={mp.utvonal} className={`navbar-mobil-link ${location.pathname === mp.utvonal ? 'aktiv' : ''}`} onClick={() => setMenuNyitva(false)}>
              <span style={{fontSize: '20px'}}>{mp.ikon}</span>{mp.nev}
            </Link>
          ))}
          <div className="navbar-mobil-elvalaszto"/>
          {felhasznalo ? (
            <>
              <Link to="/profil" className="navbar-mobil-link" onClick={() => setMenuNyitva(false)}>
                {aktivGyerek?.avatar ? (
                  <span className="navbar-gyerek-avatar" style={{width: '26px', height: '26px', fontSize: '15px', background: `linear-gradient(135deg, ${aktivGyerek.avatar.szin1}, ${aktivGyerek.avatar.szin2})`}}>
                    {aktivGyerek.avatar.ikon}
                  </span>
                ) : (
                  <span style={{fontSize: '20px'}}>👤</span>
                )}
                {aktivGyerek?.nev || felhasznalo.displayName || felhasznalo.email?.split('@')[0] || 'Profil'}
              </Link>
              <button onClick={() => { kijelentkezes(); setMenuNyitva(false); }}
                style={{padding: '12px 16px', background: '#ffebee', border: '2px solid #ffcdd2', borderRadius: '14px', fontSize: '16px', fontWeight: '700', color: '#c62828', cursor: 'pointer', textAlign: 'left'}}>
                🚪 Kilépés
              </button>
            </>
          ) : (
            <Link to="/belepes" className="navbar-mobil-link aktiv" onClick={() => setMenuNyitva(false)}>
              <span style={{fontSize: '20px'}}>🚀</span>Belépés
            </Link>
          )}
        </div>
      </nav>

      <div style={{height: '88px'}}/>
    </>
  );
}

export default Navbar;